import { useClientData } from '../../../../../client';
import { OmnibusInformationsValue, PromoStandardTextValue, PromotionType } from '../../../../../server';

export const usePromotionInfo = (
    promotion?: PromotionType,
): OmnibusInformationsValue | PromoStandardTextValue | undefined => {
    const { getClientConfigs } = useClientData();
    if (promotion === PromotionType.STANDARD) {
        return getClientConfigs('promoStandardText');
    }
    return getClientConfigs('omnibusInformations');
};
